export const getAuthToken = (): any => {
    const token = localStorage.getItem("token") ?? "";
    return token ? { Authorization: `bearer ${token}` } : null;
};
  
export const getAuthHeaders = () => {
    const token = getAuthToken();
    return token ? token : null;
};
  